import PortalQueryParamsProperties = __esri.PortalQueryParamsProperties;

export const ESRI_ITEMS = [
  'Web Map',
  'Web Scene',
  'Layers',
  'Feature Service',
  'Vector Tile Service',
  'Tile Service',
  'Scene Service',
  'GeoJson',
  'Application Configuration',
  'Map Package',
  'Layer Package',
  'CSV',
  'Shapefile',
  'Microsoft Word',
  'Microsoft Excel',
  'PDF',
] as const;
export type EsriItemType = (typeof ESRI_ITEMS)[number];

export type SortType = NonNullable<PortalQueryParamsProperties['sortField']>;
export type AllowedSortType = Extract<
  SortType,
  'num-views' | 'created' | 'modified'
>;

export const OWNERS = ['Esri', 'Public', 'Private', 'Shared'] as const;
export type OwnerType = (typeof OWNERS)[number];

export type PortalState = {
  searchTerm: string | null;
  esriItem: EsriItemType;
  owner: OwnerType;
  sort: AllowedSortType;
};

export const HYBRID = 'hybrid' as const;
